var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flats-crm-filter-mobile",class:{'open' : _vm.filterVisible}},[_c('div',{staticClass:"flats-filtter-container"},[_c('flatsFilter',{staticClass:"filter-mobile-params",attrs:{"mobileView":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }